import styled from "@emotion/styled";
import * as React from "react";

const BasicContainerDiv = styled.div`
    background-color: #f8f8fa;
    min-height: 100vh;
    overflow: hidden; // stop collapsing margin
`;

type BasicLayoutProps = React.PropsWithChildren<{}>;

export const BasicLayout: React.FC<BasicLayoutProps> = (props) => (
    <BasicContainerDiv>{props.children}</BasicContainerDiv>
);
